module.exports = __webpack_public_path__ + "img/monitorimg.25ccbc7f.png";